import React from 'react';
import './TechnicalInformation.scss';

function TechnicalInformation(props) {
  const { TechnicalInformation, openModalBox, localeInfo } = props;
  const { domain } = localeInfo;
  const generalInfo = TechnicalInformation && TechnicalInformation[0].items;
  const technicalInfo = TechnicalInformation && TechnicalInformation[1].items;
  const ProductInfo = technicalInfo && technicalInfo.concat(generalInfo);
  const count = ProductInfo && Math.round(ProductInfo.length / 2);
  const firstRowData =
    ProductInfo &&
    ProductInfo.slice(0, count - 1).map((information, index) => {
      // if (information.name === 'Frame Size') {
      //     return null;
      // }
      const hrefUrl = information?.urlDetails
        ? new URL(information?.urlDetails?.url)
        : information?.urlDetails?.url;
      return (
        <div key={index} className="tech-information">
          {index === technicalInfo.length ? (
            <div className="display-flex justify-content-between">
              <span className="info-text text-color-66">{information.name}</span>
              <span className="info-text text-color-black fw500">
                {information.name !== 'Video' &&
                information.urlDetails &&
                information.urlDetails.label === '' ? (
                  <a
                    className="defadivt-color"
                    href={hrefUrl.pathname ? hrefUrl.pathname : hrefUrl}
                  >
                    {information.value}
                  </a>
                ) : (
                  <span className="">{information.value}</span>
                )}
                {information.name !== 'Video' &&
                information.urlDetails &&
                information.urlDetails.label !== '' ? (
                  <span
                    className="fs12 default-color size-chart"
                    onClick={() => {
                      openModalBox(
                        information.urlDetails.url
                          .replace('https://www.lenskart.com/', '')
                          .replace(`${domain}/`, '')
                      );
                    }}
                  >
                    {' '}
                    {information.urlDetails.label}{' '}
                  </span>
                ) : (
                  ''
                )}
                {/* {information.name === 'Video' && information.value !== 'NO' ? <a className="fs12 default-color size-video" href={this.state.videoUrlName} onClick={this.videoUrl(this, information.value)}> Watch Video </a> : ''} */}
              </span>
            </div>
          ) : (
            <div key={index} className="display-flex justify-content-between">
              <span className="info-text text-color-66">{information.name}</span>
              <span className="info-text text-color-black fw500">
                {information.name !== 'Video' &&
                information.urlDetails &&
                information.urlDetails.label === '' ? (
                  <a
                    className="defadivt-color"
                    href={hrefUrl.pathname ? hrefUrl.pathname : hrefUrl}
                  >
                    {information.value}
                  </a>
                ) : (
                  <span className="">{information.value}</span>
                )}
                {information.name !== 'Video' &&
                information.urlDetails &&
                information.urlDetails.label !== '' ? (
                  <span
                    className="fs12 size-chart cursor-pointer"
                    onClick={() => {
                      openModalBox(
                        information.urlDetails.url
                          .replace('https://www.lenskart.com/', '')
                          .replace(`${domain}/`, '')
                      );
                    }}
                  >
                    <i className="fa fa-question-circle fs15 padding-l5"></i>
                  </span>
                ) : (
                  ''
                )}
                {/* {information.name === 'Video' && information.value !== 'NO' ? <a className="fs12 default-color size-video" href={this.state.videoUrlName} onClick={this.videoUrl(this, information.value)}> Watch Video </a> : ''} */}
              </span>
            </div>
          )}
        </div>
      );
    });
  const secondRowData = ProductInfo.slice(count - 1, ProductInfo.length).map(
    (information, index1) => {
      return (
        <div key={index1} className="tech-information">
          <div key={index1} className="display-flex justify-content-between">
            <span className="info-text text-color-66 fb-40">{information.name}</span>
            <span className="info-text text-color-black fw500 fb-60">
              {information.name !== 'Product Warranty'
                ? information.value
                : information.value.split('<br>')[0]}
              {information.name !== 'Video' && information.urlDetails ? (
                <span
                  className="fs12 size-chart cursor-pointer"
                  onClick={() => {
                    openModalBox(
                      information.urlDetails.url
                        .replace('https://www.lenskart.com/', '')
                        .replace(`${domain}/`, '')
                    );
                  }}
                >
                  <i className="fa fa-question-circle fs15 padding-l5"></i>
                </span>
              ) : (
                ''
              )}
              {/* {information.name === 'Video' && information.value !== 'NO' ? <a className="fs12 default-color size-video" href={this.state.videoUrlName} onClick={this.videoUrl(this, information.value)}> Watch Video </a> : ''} */}
            </span>
          </div>
        </div>
      );
    }
  );
  return (
    <div className="pdpInfo display-flex justify-content-between">
      <div className="fb-40">{firstRowData}</div>
      <div className="fb-55 padding-l30">{secondRowData}</div>
    </div>
  );
}
export default TechnicalInformation;
